<div class="layout-container" role="dialog" aria-labelledby="entity-modal-label">
    <div class="close-icon-container">
        <p-button
        icon="pi pi-times"
        [autofocus]="true" 
        [rounded]="true"
        [text]="true"
        [disabled]="false"
        [attr.aria-disabled]="false"
        [ariaLabel]=" 'iaa.aria.close' | translate "
        (click)="onCloseEntityPage()"
        (keydown.enter)="onCloseEntityPage()"
        [tabindex]="0"
        ></p-button>
    </div>
    <div *ngIf="!isSmallScreen || !mapContent" [ngClass]="{'desktop-layout': !isSmallScreen, 'tablet-layout': isSmallScreen}">
        <div class="details-panel" *ngIf="!loading">
            <p-card>
                <ng-template pTemplate="title">
                    <div class="content-title" id="entity-modal-label">
                        <h2>{{ detailsContentTitle }}</h2>
                    </div>
                </ng-template>
                <ng-container *ngTemplateOutlet="detailsContent"></ng-container>
            </p-card>
        </div>
        <div class="details-panel" *ngIf="loading">
            <p-card>
                <ng-template pTemplate="title">
                    <div class="content-title">
                    </div>
                </ng-template>
                <div class="p-4 skeleton-content">
                    <p-skeleton height="2rem" width="100%" styleClass="mb-2"></p-skeleton>
                    <p-skeleton height="4rem" width="100%" styleClass="mb-2"></p-skeleton>
                    <p-skeleton height="2rem" width="80%" styleClass="mb-2"></p-skeleton>
                    <p-skeleton height="12rem" width="100%" styleClass="mb-2"></p-skeleton>
                    <p-skeleton height="2rem" width="90%"></p-skeleton>
                </div>
            </p-card>
        </div>

        <div class="map-panel" *ngIf="!loading && !!mapContent">
            <p-card>
                <ng-template pTemplate="title">
                    <div class="content-title">
                        <h2>{{ mapContentTitle }}</h2>
                    </div>
                </ng-template>
                <ng-container *ngTemplateOutlet="mapContent"></ng-container>
            </p-card>
        </div>
        <div class="map-panel" *ngIf="loading && !!mapContent">
            <p-card>
                <ng-template pTemplate="title">
                    <div class="content-title">
                    </div>
                </ng-template>
                <p-skeleton height="calc(100vh - 20rem)" width="100%"></p-skeleton>
            </p-card>
        </div>

    </div>

    <div *ngIf="isSmallScreen && !!mapContent" class="tablet-layout">
        <p-tabView [scrollable]="true" (onChange)="setActiveTab($event)" [(activeIndex)]="activeTabIndex" [attr.aria-label]="'iaa.aria.documentViewMapView' | translate">
            <p-tabPanel>
                <ng-template pTemplate="header">
                    <ng-container *ngIf="loading">
                        <p-skeleton width="80px" height="1.5rem"></p-skeleton>
                    </ng-container>
                    <ng-container *ngIf="!loading">
                       {{'iaa.aria.infoView' | translate}}
                        <img class="tab-icon" [src]="activeTab === 'details' ? 'assets/entity-text-gold.svg' : 'assets/entity-text-blue.svg'" alt="">
                    </ng-container>
                </ng-template>

                <ng-template pTemplate="content">
                    <p-card>
                        <ng-template pTemplate="title">
                            <div class="content-title" *ngIf="!loading"  id="entity-modal-label">
                                <h2>{{ detailsContentTitle }}</h2>
                            </div>
                            <div class="content-title" *ngIf="loading">
                            </div>
                        </ng-template>
                        
                        <div class="details-content" *ngIf="!loading">
                            <ng-container *ngTemplateOutlet="detailsContent"></ng-container>
                        </div>
                        <div class="details-content p-4" *ngIf="loading">
                            <p-skeleton height="2rem" width="100%" styleClass="mb-2"></p-skeleton>
                            <p-skeleton height="4rem" width="100%" styleClass="mb-2"></p-skeleton>
                            <p-skeleton height="2rem" width="80%" styleClass="mb-2"></p-skeleton>
                            <p-skeleton height="12rem" width="100%" styleClass="mb-2"></p-skeleton>
                            <p-skeleton height="2rem" width="90%"></p-skeleton>
                        </div>
                    </p-card>
                </ng-template>
            </p-tabPanel>

            <p-tabPanel>
                <ng-template pTemplate="header">
                    <ng-container *ngIf="loading">
                        <p-skeleton width="80px" height="1.5rem"></p-skeleton>
                    </ng-container>
                    <ng-container *ngIf="!loading">
                        {{'iaa.aria.mapView' | translate}}
                        <img class="tab-icon" [src]="activeTab === 'map' ? 'assets/entity-location-gold.svg' : 'assets/entity-location-blue.svg'" alt="">
                    </ng-container>
                </ng-template>

                <ng-template pTemplate="content">
                    <p-card>
                            <ng-container *ngTemplateOutlet="mapContent"></ng-container>
                    </p-card>
                </ng-template>
            </p-tabPanel>
        </p-tabView>
    </div>
    <div class="footer-container">
        <ng-container *ngTemplateOutlet="footer"></ng-container>
    </div>

</div>